import { ReportListItemData } from './report-base';

export class PaymentObject extends ReportListItemData {
  userCardType: string;
  amount: number;
  paymentDate: Date;
}

export class PaymentReport {
  count: number;
  totalAmount: number;
  list: PaymentObject[];

  constructor(data: any = {}) {
    this.count = +data.count;
    this.totalAmount = +data.totalAmount;
    this.list = data.list ? data.list.map(l => new PaymentObject(l)) : [];
  }
}



// WEBPACK FOOTER //
// ./src/app/models/reports/payment-report.ts